import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next';
import { usePageSeo } from './usePageSeo';


export const Contact = () => {
    const form = useRef();
    const { t } = useTranslation();
    usePageSeo('seo.contact.title', 'seo.contact.description');

    const sendEmail = (e) => {
        e.preventDefault();

        console.log(e);
        
        emailjs.sendForm('service_ktjui6o', 'template_539cd91', form.current, 'OUilPQciiowAdN6LS').then((result) => 
        {
            console.log(result.text);
            alert(t('contact.success'));
        }, 
        (error) => 
        {
            console.log(error.text);
            alert(t('contact.error', { error: error.text || error }));
        });
    }

    return (
        <span id="contact">
            <div class="vb-page">
                <div class="container vb-margin">
                    <div class="row justify-content-center">
                        <div class="col-xxl-4 col-xl-5 col-lg-5 col-md-8 col-xs-8 vb-form-container">
                            <form ref={form} onSubmit={sendEmail}>
                                <div class="vb-title-container">
                                    <span class="vb-form-title">
                                        {t('contact.title')}
                                    </span>
                                </div>
                                <div class="vb-title-container">
                                    <p class="vb-form-subtitle">
                                        {t('contact.subtitle')}
                                    </p>
                                </div>
                                <div class="vb-input-section">
                                    <label for="name" class="form-label">{t('contact.name')}</label>
                                    <input type="text" class="form-control" id="name" name="from_name"/>
                                </div>
                                <div class="vb-input-section">
                                    <label for="email" class="form-label">{t('contact.email')}</label>
                                    <input type="email" class="form-control" name="from_mail" id="email"/>
                                </div>
                                <div class="vb-input-section">
                                    <label for="message" class="form-label">{t('contact.message')}</label>
                                    <textarea class="form-control vb-textarea" aria-label="With textarea" id="message" name="message"></textarea>
                                </div>
                                <button type="submit" class="btn btn-primary vb-button-wide">{t('contact.submit')}</button>
                            </form>
                        </div>
                    </div> 
                </div>
            </div>
        </span>
        
    );
}
